export default {
  // this.video, reference = this.$refs.video
  startCamera (video) {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ 
        video: {
          width: {min: 360, ideal:640, max:1920},
          height: {min:240, ideal:480, max:1080},
        } 
      }).then(stream => {
        video.srcObject = stream
        video.play()
        console.log("cam is mounted");
      })
    }
  },
  capture (video,captures,canvas) {
    canvas.getContext('2d').drawImage(video, 0, 0, 500, 500)
    captures.push(canvas.toDataURL('image/png'))
    console.log(captures)
  },
  pauseCamera (video){
    video.pause();
    console.log("Vid pause");
  },
  stopCamera (video){
    video.srcObject.getTracks().forEach(device => {
      device.stop();
      console.log("Vid off");
      video.srcObject = null;
    });
  },
};
